module.exports = __webpack_public_path__ + "img/1_1-piazza-0.f82d60d1.png";